import { useCallback } from 'react';

import { useExperimentFlag } from '@zenbusiness/application-commons-experiments';
import { useIntl } from '@zenbusiness/application-commons-intl';

import { ENABLE_DASHBOARD_LINK_TO_MANAGE_COOKIES } from '#client/constants/experimentsFlags';

import { CookiePreferences as StyledCookiePreferences } from './AppFooter.style';

function isCookiePreferencesAvailable() {
  return typeof window !== 'undefined'
    && Boolean(window.Osano?.cm?.showDrawer);
}

function CookiePreferences() {
  const enableDashboardLinkToManageCookies = useExperimentFlag(
    ENABLE_DASHBOARD_LINK_TO_MANAGE_COOKIES,
    false
  );

  const { formatMessage } = useIntl();

  const handleCookiePreferencesClick = useCallback(() => {
    // Safely access Osano cookie manager
    window.Osano.cm.showDrawer('osano-cm-dom-info-dialog-open');
  }, []);

  // Don't render if cookie preferences are not available
  if (!isCookiePreferencesAvailable() || !enableDashboardLinkToManageCookies) {
    return null;
  }

  const label = formatMessage({ id: 'dashboard.footer.cookiePreferences.label' });
  return (
    <StyledCookiePreferences
      onClick={handleCookiePreferencesClick}
      aria-label={label}
      clickstreamProps={{
        elementName: 'cookie_preferences',
        elementPosition: 'footer'
      }}
    >
      {label}
    </StyledCookiePreferences>
  );
}

export default CookiePreferences;
